import React from "react";
import PropTypes from "prop-types";
import "./PageLayout.css";
import Link from "gatsby-link";
import Sidebar from "../components/Sidebar";
import { Provider } from "react-redux";
import createStore from "../state/createStore";
import axios from "axios";
import "./styles.module.css";
import ReactPixel from "react-facebook-pixel";
import { validationForEmail } from "../js/regex";

const store = createStore();

// Constants
const LOGOS = {
  header: "https://bawamasalacompany.com/assets/images/logo-dark.png",
  mobile: "https://bawamasalacompany.com/assets/images/logo-dark.png",
  footer: "https://bawamasalacompany.com/assets/images/BE(LOGO)footer200x200.png",
};

const SOCIAL_LINKS = [
  { icon: "fa-facebook", url: "https://www.facebook.com/bawamasalacompany" },
  { icon: "fa-instagram", url: "https://www.instagram.com/bawamasalacompany/" },
  { icon: "fa-x-twitter", url: "https://twitter.com/bawamasalaco" },
  { icon: "fa-linkedin", url: "https://www.linkedin.com/company/18855306/admin/overview/" },
  { icon: "fa-youtube", url: "https://www.youtube.com/channel/UCWX7VFCNfrmjeXaAqYtyoQA?view_as=subscriber" },
];

const NAVIGATION_MENU = [
  { title: "Home", link: "/" },
  { title: "Products", link: "/store" },
  { title: "Legacy", link: "/legacy" },
  { title: "Dealerships", link: "/dealers" },
  { title: "Masala Dabba", link: "/recipes" },
  { title: "Contact", link: "/connect" },
];

const POPUP_TIMEOUT = 43200000; // 12 hours

export class PageLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowSidebar: false,
      cartNumber: 0,
      findingRegion: true,
      show: false,
      isSubmittingEmail: false,
      subscriberEmail: "",
      emailError: false,
      isSubmitted: false,
      isScrolled: false,
      // Enquiry form state
      showEnquiryForm: false,
      isSubmittingEnquiry: false,
      enquiryForm: {
        fullName: "",
        mobile: "",
        address: "",
        purpose: "",
        message: "",
      },
      enquiryErrors: {},
      enquirySubmitted: false,
    };
    this.regionName = "Delhi";
  }

  componentDidMount() {
    this.initializePixelTracking();
    this.initializeCart();
    this.checkPopupDisplay();
    this.fetchUserLocation();
    this.addScrollListener();
    this.showEnquiryFormDelayed();
  }

  componentWillUnmount() {
    this.removeScrollListener();
  }

  addScrollListener = () => {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  };

  removeScrollListener = () => {
    window.removeEventListener("scroll", this.handleScroll);
  };

  handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shouldBeScrolled = scrollTop > 100; // Increased threshold for better UX

    if (shouldBeScrolled !== this.state.isScrolled) {
      this.setState({ isScrolled: shouldBeScrolled });
    }
  };

  initializePixelTracking = () => {
    const { location } = this.props;
    ReactPixel.init("145006083100066");
    ReactPixel.track("ViewContent", location);
  };

  initializeCart = () => {
    const { dispatch } = store;
    const defaultCart = { products: {}, totalNumber: 0 };

    const storedCart = localStorage.getItem("cart");
    if (storedCart) {
      const parsedCart = JSON.parse(storedCart);
      if (parsedCart.products && parsedCart.totalNumber !== undefined) {
        dispatch({ type: "SET_TO_CART", addToCartList: parsedCart });
      } else {
        this.setDefaultCart(dispatch, defaultCart);
      }
      this.setState({ cartNumber: store.getState().addToCartList.totalNumber });
    } else {
      this.setDefaultCart(dispatch, defaultCart);
    }
  };

  setDefaultCart = (dispatch, cart) => {
    dispatch({ type: "SET_TO_CART", addToCartList: cart });
    localStorage.setItem("cart", JSON.stringify(cart));
  };

  checkPopupDisplay = () => {
    const popupShown = localStorage.getItem("popupShown");

    if (!popupShown) {
      this.showPopup();
    } else {
      const { timestamp } = JSON.parse(popupShown);
      const timeDiff = new Date() - new Date(timestamp);

      if (timeDiff > POPUP_TIMEOUT) {
        this.showPopup();
      }
    }
  };

  showPopup = () => {
    this.setState({ show: true }, () => {
      const data = { timestamp: new Date() };
      localStorage.setItem("popupShown", JSON.stringify(data));
    });
  };

  fetchUserLocation = () => {
    const { dispatch } = store;

    axios
      .get("https://extreme-ip-lookup.com/json/")
      .then((response) => {
        const { data } = response;
        this.regionName = data.region;
        dispatch({ type: "SET_MACHINE_ADDRESS", ipData: data });
        this.setState({ findingRegion: true });
      })
      .catch((error) => {
        console.error("Failed to fetch location:", error);
        this.setState({ findingRegion: true });
      });
  };

  toggleSidebar = () => {
    this.setState((prevState) => ({ isShowSidebar: !prevState.isShowSidebar }));
  };

  toggleModal = () => {
    this.setState((prevState) => ({ show: !prevState.show }));
  };

  handleEmailChange = (e) => {
    this.setState({ subscriberEmail: e.target.value, emailError: false });
  };

  submitEmail = () => {
    const { subscriberEmail } = this.state;

    if (!validationForEmail(subscriberEmail)) {
      this.setState({ emailError: "Please enter a valid email address" });
      return;
    }

    this.setState({ emailError: false, isSubmittingEmail: true });

    const emailParams = `email=${subscriberEmail}&coupon=1`;
    const apiUrl = `https://blackelephantdigital.in/blackele/sunny/api/bmc-api/public/newsletter_subscriberBMC?${emailParams}`;

    axios
      .get(apiUrl)
      .then((response) => {
        const { data } = response;
        if (data === "Success") {
          this.setState({ isSubmitted: true, isSubmittingEmail: false });
        } else {
          this.setState({
            emailError: "This email is already subscribed",
            isSubmittingEmail: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          emailError: "Failed to subscribe. Please try again.",
          isSubmittingEmail: false,
        });
      });
  };

  // Enquiry form methods
  toggleEnquiryForm = () => {
    this.setState((prevState) => ({
      showEnquiryForm: !prevState.showEnquiryForm,
      enquirySubmitted: false,
      enquiryErrors: {},
      enquiryForm: {
        fullName: "",
        mobile: "",
        address: "",
        purpose: "",
        message: "",
      },
    }));
  };

  handleEnquiryInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      enquiryForm: {
        ...prevState.enquiryForm,
        [name]: value,
      },
      enquiryErrors: {
        ...prevState.enquiryErrors,
        [name]: "",
      },
    }));
  };

  validateEnquiryForm = () => {
    const { enquiryForm } = this.state;
    const errors = {};

    if (!enquiryForm.fullName.trim()) {
      errors.fullName = "Full name is required";
    }

    if (!enquiryForm.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(enquiryForm.mobile.replace(/\s/g, ""))) {
      errors.mobile = "Please enter a valid 10-digit mobile number";
    }

    if (!enquiryForm.address.trim()) {
      errors.address = "Address is required";
    }

    if (!enquiryForm.purpose) {
      errors.purpose = "Please select purpose of enquiry";
    }

    if (!enquiryForm.message.trim()) {
      errors.message = "Message is required";
    }

    return errors;
  };

  submitEnquiryForm = () => {
    const errors = this.validateEnquiryForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ enquiryErrors: errors });
      return;
    }

    this.setState({ isSubmittingEnquiry: true, enquiryErrors: {} });

    const { enquiryForm } = this.state;
    const formData = new FormData();
    formData.append("full_name", enquiryForm.fullName);
    formData.append("mobile", enquiryForm.mobile);
    formData.append("address", enquiryForm.address);
    formData.append("purpose", enquiryForm.purpose);
    formData.append("message", enquiryForm.message);

    // Replace with your actual API endpoint
    const apiUrl = "https://bawamasalacompany.com/api/public/index.php/quickenquiry";

    axios
      .post(apiUrl, formData)
      .then((response) => {
        this.setState({
          enquirySubmitted: true,
          isSubmittingEnquiry: false,
        });
        setTimeout(() => {
          this.toggleEnquiryForm();
        }, 2000);
      })
      .catch((error) => {
        console.error("Failed to submit enquiry:", error);
        this.setState({
          enquiryErrors: { submit: "Failed to submit enquiry. Please try again." },
          isSubmittingEnquiry: false,
        });
      });
  };

  showEnquiryFormDelayed = () => {
    // Show enquiry form after 3 seconds on all devices
    setTimeout(() => {
      this.setState({ showEnquiryForm: true });
    }, 3000);
  };

  renderEnquiryPopup = () => {
    const { showEnquiryForm, isSubmittingEnquiry, enquiryForm, enquiryErrors, enquirySubmitted } = this.state;

    const purposeOptions = [
      { value: "", label: "Select Purpose" },
      { value: "wholesale", label: "Bulk / Wholesale Purchase" },
      { value: "distributor", label: "Distributor Enquiry" },
      { value: "retail", label: "Retail Purchase" },
      { value: "feedback", label: "Feedback / Other" },
    ];

    return (
      <div
        className={`enquiry__slide_panel ${showEnquiryForm ? "enquiry__slide_panel--open" : ""}`}
        onClick={!showEnquiryForm ? this.toggleEnquiryForm : undefined}
      >
        <div className="enquiry__panel_content" onClick={(e) => e.stopPropagation()}>
          <div className="cross__icon" onClick={this.toggleEnquiryForm}>
            <i className="fa fa-times"></i>
          </div>
          <div className="enquiry__form_wrapper">
            {enquirySubmitted ? (
              <div className="success-message">
                <h3>Thank You!</h3>
                <p>Your enquiry has been submitted successfully. We will get back to you soon.</p>
              </div>
            ) : (
              <div>
                <h3>Quick Enquiry</h3>
                <p className="enquiry__description">Get in touch with us for all your spice needs!</p>

                <div className="form-group">
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name *"
                    value={enquiryForm.fullName}
                    onChange={this.handleEnquiryInputChange}
                    className={`form-control ${enquiryErrors.fullName ? "error" : ""}`}
                  />
                  {enquiryErrors.fullName && <div className="error-text">{enquiryErrors.fullName}</div>}
                </div>

                <div className="form-group">
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number *"
                    value={enquiryForm.mobile}
                    onChange={this.handleEnquiryInputChange}
                    className={`form-control ${enquiryErrors.mobile ? "error" : ""}`}
                  />
                  {enquiryErrors.mobile && <div className="error-text">{enquiryErrors.mobile}</div>}
                </div>

                <div className="form-group">
                  <textarea
                    name="address"
                    placeholder="Address *"
                    value={enquiryForm.address}
                    onChange={this.handleEnquiryInputChange}
                    className={`form-control ${enquiryErrors.address ? "error" : ""}`}
                    rows="2"
                  />
                  {enquiryErrors.address && <div className="error-text">{enquiryErrors.address}</div>}
                </div>

                <div className="form-group">
                  <select
                    name="purpose"
                    value={enquiryForm.purpose}
                    onChange={this.handleEnquiryInputChange}
                    className={`form-control ${enquiryErrors.purpose ? "error" : ""}`}
                  >
                    {purposeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {enquiryErrors.purpose && <div className="error-text">{enquiryErrors.purpose}</div>}
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Message *"
                    value={enquiryForm.message}
                    onChange={this.handleEnquiryInputChange}
                    className={`form-control ${enquiryErrors.message ? "error" : ""}`}
                    rows="3"
                  />
                  {enquiryErrors.message && <div className="error-text">{enquiryErrors.message}</div>}
                </div>

                {enquiryErrors.submit && <div className="error-text">{enquiryErrors.submit}</div>}

                <button onClick={this.submitEnquiryForm} disabled={isSubmittingEnquiry} className="enquiry-submit-btn">
                  {isSubmittingEnquiry ? "Submitting..." : "Submit Enquiry"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderHeader = (route) => {
    const { isScrolled } = this.state;

    return (
      <div className={`page-layout__viewport__header ${isScrolled ? "page-layout__viewport__header--scrolled" : ""}`}>
        <div className={`header__logo ${isScrolled ? "header__logo--scrolled" : ""}`}>
          <Link to="/">
            <img src={LOGOS.header} alt="BMC Logo" className="img img-responsive" />
          </Link>
        </div>

        <nav className="menu__bar">
          <ul>
            {NAVIGATION_MENU.map((item) => (
              <li key={item.title} className={`menu__text${`/${route}` === item.link ? "-active" : ""}`}>
                <Link to={item.link}>{item.title}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className={`mobile_sidebar ${isScrolled ? "mobile_sidebar--scrolled" : ""}`}>
          <div className="logo">
            <Link to="/">
              <img src={LOGOS.mobile} alt="BMC Logo" className="logo-img" />
              {/* <div className="logo__text">Bawa Masala Company</div> */}
            </Link>
          </div>
          <div className="hmb" onClick={this.toggleSidebar}>
            <i className="fa fa-bars" />
          </div>
          <Sidebar show={this.state.isShowSidebar} Menu={NAVIGATION_MENU} onHide={this.toggleSidebar} activePathname={route} />
        </div>
      </div>
    );
  };

  renderFooter = () => {
    const footerContent = (
      <div className="middle__content">
        <div>
          <b>BAWA MASALA COMPANY</b>
        </div>
        <div>B-11, Lawrence Road, Industrial Area, New Delhi - 110 035</div>
      </div>
    );

    return (
      <main>
        <div className="page-layout__viewport__footer_content">
          <div className="row">
            <div className="col-md-3 col-sm-3">
              <div className="left__content">
                <i className="fa fa-copyright" /> Bawa Masala Company {new Date().getFullYear()}. All Rights Reserved
              </div>
            </div>
            <div className="col-md-6 col-sm-6">{footerContent}</div>
            <div className="col-md-3 col-sm-3">
              <div className="right__content">
                Powered By{" "}
                <a href="http://blackelephantdigital.com" target="_blank" rel="noopener noreferrer">
                  <img alt="Black Elephant Digital" src={LOGOS.footer} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="page-layout__viewport__footer_content_mobile">
          {footerContent}
          <div className="left__content">
            <i className="fa fa-copyright" />
            Bawa Masala Company {new Date().getFullYear()}. All Rights Reserved
          </div>
          <div className="right__content">
            Powered By{" "}
            <a href="http://blackelephantdigital.com" target="_blank" rel="noopener noreferrer">
              <img alt="Black Elephant Digital" src={LOGOS.footer} />
            </a>
          </div>
        </div>
      </main>
    );
  };

  renderSocialSidebar = () => (
    <div className="page-layout__viewport__social__sidebar">
      <div className="social__icons">
        {SOCIAL_LINKS.map((social, index) => (
          <span key={index} className="icon">
            <a rel="noopener noreferrer" href={social.url} target="_blank" aria-label={`Visit our ${social.icon.replace("fa-", "")} page`}>
              <i className={`fa-brands ${social.icon}`} />
            </a>
          </span>
        ))}
      </div>
    </div>
  );

  render() {
    const { children, location } = this.props;
    const { isScrolled } = this.state;
    const route = location.pathname.split("/")[1];
    const appChildren = process.env.NODE_ENV === "production" ? children({ location }) : children();

    return (
      <Provider store={store}>
        <div className="page-layout__viewport" style={{ paddingTop: "0" }}>
          {this.renderSocialSidebar()}
          {this.renderHeader(route)}
          <div className={`page-layout__viewport__middle_content ${this.state.isScrolled ? "page-layout__viewport__middle_content--scrolled" : ""}`}>
            {appChildren}
          </div>
          {this.renderFooter()}
          {this.renderEnquiryPopup()}
        </div>
      </Provider>
    );
  }
}

PageLayout.propTypes = {
  children: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx